document.addEventListener('alpine:init', () => {
  // keep your existing modal cart init
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'cascade:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');

        // --- ADD THIS: track drawer type ---
        const store = Alpine.store('modals');

        // Save original open/close functions
        const originalOpen = store.open;
        const originalClose = store.close;

        // Override open to track type
        store.open = function(name) {
          if (name === 'cart') {
            this.rightDrawerType = 'cart';
          } else {
            this.rightDrawerType = null;
          }
          originalOpen.call(this, name);
        };

        // Override close to clear type
        store.close = function(name) {
          if (name === 'cart') {
            this.rightDrawerType = null;
          }
          originalClose.call(this, name);
        };
      },
    };
  });
});
